import { z } from "zod";
import { assignedSupervisorsSchema } from "../account/assignedSupervisors.js";

export default {
  params: z.object({
    supervisorOrgId: z.string(),
    siren: z.string().regex(/^\d{9}$/),
    contractTemplateId: z.string(),
    assignedSupervisors: assignedSupervisorsSchema,
    transferAmountThreshold: z.number().nonnegative().nullable(),
    // A cleared number field holds "" in the form
    notifications: z.object({
      balance: z.object({
        max: z.number().nullable().catch(null),
        min: z.number().nullable().catch(null),
      }),
      transaction: z.object({ max: z.number().nullable().catch(null) }),
      inactivity: z.object({ enabled: z.boolean(), days: z.number().int().positive() }),
    }),
  }),
  response: z.string(),
  errorDetails: z.object({
    reason: z.enum(["noSignatureApiContract", "contractTemplateNotFound", "noEligibleAccount"]),
  }),
};
